/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export interface IAviDataGridState {
    [key: string]: {
        gridColumnVisibility: {
            [key: string]: boolean;
        };
    };
}

export const initialState: IAviDataGridState = {};
